import React from "react";
import { facilitators } from "../data";
import SectionHead from "./SectionHead";

const Facilitators = () => (
  <section className="team-section" aria-labelledby="team-heading">
    <div className="container">
      <SectionHead
        headingId="team-heading"
        title={
          <>
            Who's in the <em>room</em>.
          </>
        }
        body="One of us, two of us, or all three. We've taught AI, Innovation, Creativity and digital transformation in 25+ countries, at places such as LBS, PwC, Ogilvy and the UN."
      />
      <div className="team-grid">
        {facilitators.map((facilitator) => (
          <div key={facilitator.name} className="team-card">
            <div className="team-portrait">
              <img src={facilitator.image} alt={facilitator.name} />
            </div>
            <h4>{facilitator.name}</h4>
            <p className="role">{facilitator.role}</p>
            <p>{facilitator.bio}</p>
            <div className="team-links">
              {facilitator.links.map((link) => (
                <a
                  key={link.href}
                  className={link.label === "LinkedIn" ? "linkedin" : "website"}
                  href={link.href}
                  target="_blank"
                  rel="noopener"
                  aria-label={
                    link.label === "LinkedIn"
                      ? `${facilitator.name} on LinkedIn`
                      : `${facilitator.name}'s website (opens in new tab)`
                  }
                >
                  {link.label} &rarr;
                </a>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Facilitators;
